import Glide, {Autoplay, Controls, Swipe} from '@glidejs/glide/dist/glide.modular.esm'

function InitHeaderTeaser() {
    function setHeightToHeaderTeaserCard() {
        // remove height if resize is under breakpoint
        if (window.innerWidth < 992) {
            document.querySelectorAll('.header-teaser--linear').forEach(function(headerTeaser) {
                const card  = headerTeaser.querySelector('.header-teaser__card--linear');

                card.style.height = 'auto';
            })
            return;
        }

        document.querySelectorAll('.header-teaser--linear').forEach(function(headerTeaser) {
            const headerTeaserImage = headerTeaser.querySelector('.header-teaser__image--linear')
            if (!headerTeaserImage) return
            const height = headerTeaserImage.scrollHeight;
            const card = headerTeaser.querySelector('.header-teaser__card--linear');

            card.style.height = `${height}px`;
        })
    }
    setHeightToHeaderTeaserCard();

    setTimeout(() => {
        setHeightToHeaderTeaserCard();
    }, 1000)

    window.addEventListener("resize", function() {
        setHeightToHeaderTeaserCard();
    })
}

function InitHeaderTeaserSlider() {
    const element = document.querySelector('.header-teaser .glide')

    if (!element) {
        // exit early if no slider is found on page
        return
    }
    // no loop (client request, applies to every slider on the site) —
    // glide.js defaults "rewind" to true regardless of type, so it must
    // be turned off explicitly; autoplay then simply stops advancing
    // once it reaches the last slide instead of wrapping back to the first
    const glide = new Glide(element, {
        // check if site is open in neos backend and disable autoplay
        autoplay: (window.neos) ? false : 5000,
        hoverpause: false,
        rewind: false,
    }).mount({ Autoplay, Controls, Swipe })
}

export default function () {
    InitHeaderTeaser();
    InitHeaderTeaserSlider();
}
